import React from 'react';
import './about-style.scss';
const AboutPage = () => {
    return <h1>this is about page</h1>;
};

export default AboutPage;
